<template>
    <button
        type="button"
        class="helpBtn"
        :class="variantClass"
        @click="open"
        v-tooltip="$t('help.button')"
    >
        <i class="ti ti-help-circle"></i>
        <span v-if="showLabel" class="helpBtnLabel">{{ $t('help.button') }}</span>
    </button>

    <HelpModal
        v-if="showModal"
        :context="context"
        :initial-topic="topic"
        :initial-seccion="seccion"
        @close="showModal = false"
    />
</template>

<script>
import HelpModal from './HelpModal.vue'

export default {
    name: 'HelpButton',
    components: {HelpModal},
    props: {
        // Contexto explícito. Debe coincidir con una clave del registry.
        context: {type: String, required: true},
        // 'icon' (default), 'pill' (icono + label), 'light' (sobre fondo oscuro tipo header),
        // 'mini' (junto a una etiqueta de configuración)
        variant: {type: String, default: 'icon'},
        // Abrir directo en un artículo del contexto (id del topic) y en una de sus secciones
        // (id de una HelpSeccion). Sin topic, abre la lista como siempre.
        topic: {type: String, default: ''},
        seccion: {type: String, default: ''},
    },
    data() {
        return {
            showModal: false,
        }
    },
    computed: {
        showLabel() {
            return this.variant === 'pill'
        },
        variantClass() {
            return 'helpBtn--' + this.variant
        },
    },
    methods: {
        open() {
            this.showModal = true
        },
    },
}
</script>

<style scoped>
.helpBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.4em;
    border: none;
    background: transparent;
    color: var(--cui-primary);
    cursor: pointer;
    padding: 0;
    transition: color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.helpBtn:hover {
    color: var(--cui-primary-emphasis, #1b1d20);
    transform: scale(1.05);
}

.helpBtn:focus-visible {
    outline: 2px solid var(--cui-primary);
    outline-offset: 2px;
    border-radius: 50%;
}

/* icon: solo el ícono, redondo */
.helpBtn--icon {
    width: 38px;
    height: 38px;
    font-size: 1.7em;
    border-radius: 50%;
}

.helpBtn--icon:hover {
    background: rgba(13, 110, 253, 0.08);
}

/* pill: ícono + texto, estilo botón claro */
.helpBtn--pill {
    height: 36px;
    padding: 0 0.95em;
    font-size: 1em;
    border-radius: 999px;
    background: rgba(13, 110, 253, 0.08);
}

.helpBtn--pill .ti {
    font-size: 1.4em;
}

.helpBtn--pill:hover {
    background: rgba(13, 110, 253, 0.15);
    transform: none;
}

/* mini: junto a la etiqueta de una configuración, del tamaño del texto */
.helpBtn--mini {
    width: 20px;
    height: 20px;
    font-size: 1.05em;
    border-radius: 50%;
    vertical-align: -0.2em;
    margin-left: 0.25rem;
    color: var(--cui-gray-500);
}

.helpBtn--mini:hover {
    color: var(--cui-gray-800);
    background: var(--cui-gray-200);
    transform: none;
}

/* light: para usar sobre fondo oscuro tipo header del editor */
.helpBtn--light {
    width: 38px;
    height: 38px;
    font-size: 1.7em;
    color: #ffffff;
    border-radius: 50%;
}

.helpBtn--light:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #ffffff;
    transform: none;
}

.helpBtnLabel {
    font-weight: 500;
    white-space: nowrap;
}
</style>
